<div class="auth-container">
  <div class="auth-background">
    <div class="gradient-orb gradient-orb-1"></div>
    <div class="gradient-orb gradient-orb-2"></div>
    <div class="gradient-orb gradient-orb-3"></div>
  </div>

  <div class="auth-content">
    <div class="auth-card">
      <!-- Top bar: Brand + Theme-Toggle (Konzept A) -->
      <div class="desk-top">
        <div class="fp-brand">
          <img
            src="../../../../../assets/img/logo-text.svg"
            alt="FixPlaner"
            class="logo"
          />
        </div>
        <div class="auth-top-actions">
          <xds-icon-button
            [icon]="'fa-light ' + getThemeIconClass()"
            [ariaLabel]="'REG_THEME_TOGGLE_LABEL' | translate"
            (clicked)="toggleTheme()"
          ></xds-icon-button>
        </div>
      </div>

      <!-- Einladungsdaten (BE-12 P4): Ladezustand als Live-Region, die immer im DOM steht -->
      <div class="invitation-preview-status" role="status" aria-live="polite" data-testid="invitation-preview-loading">
        <ng-container *ngIf="previewState === 'loading'">
          <i class="fa-light fa-spinner-third fa-spin" aria-hidden="true"></i>
          {{ "ACCEPT_INV_LOADING" | translate }}
        </ng-container>
      </div>

      <!-- Vorabruf gescheitert: kein Assistent, kein Passwortformular -->
      <div class="submit-error" *ngIf="previewState === 'error' && previewError">
        <xds-banner #previewErrorBanner variant="danger" tabindex="-1" data-testid="invitation-preview-error">{{ previewError }}</xds-banner>
        <xds-button
          *ngIf="previewShowLogin"
          variant="secondary"
          iconLeft="fa-light fa-arrow-right-to-bracket"
          (clicked)="goToLogin()"
          data-testid="invitation-preview-go-to-login"
        >
          {{ "GO_TO_LOGIN" | translate }}
        </xds-button>
      </div>

      <ng-container *ngIf="previewState === 'ready'">
      <!-- Progress Indicator -->
      <div class="wizard-progress">
        <div class="progress-steps">
          <div class="progress-step" [class.active]="currentStep === 1" [class.completed]="currentStep > 1">
            <div class="step-circle">
              <i class="fa-light fa-shield-check" *ngIf="currentStep === 1"></i>
              <i class="fa-light fa-check" *ngIf="currentStep > 1"></i>
            </div>
            <span class="step-label">{{ "WIZARD_STEP_CONSENT" | translate }}</span>
          </div>
          <div class="progress-line" [class.completed]="currentStep > 1"></div>
          <div class="progress-step" [class.active]="currentStep === 2">
            <div class="step-circle">
              <i class="fa-light fa-key"></i>
            </div>
            <span class="step-label">{{ "WIZARD_STEP_PASSWORD" | translate }}</span>
          </div>
        </div>
        <div class="progress-text">
          {{ "STEP" | translate }} {{ currentStep }} {{ "OF" | translate }} 2
        </div>
      </div>

      <!-- ========================================== -->
      <!-- STEP 1: GDPR CONSENT -->
      <!-- ========================================== -->
      <div class="wizard-step" *ngIf="currentStep === 1" [@fadeIn]>
        <!-- Greeting — Welcome-Step (Eyebrow weg, Wizard-Progress oben zeigt schon Step) -->
        <div class="desk-greet">
          <h1>
            {{ "ACCEPT_INV_GREET_LINE_1" | translate }}
            <span class="grad">{{ "ACCEPT_INV_GREET_BRAND" | translate }}</span>
          </h1>
          <p class="lede">{{ "WIZARD_STEP1_SUBTITLE" | translate }}</p>
        </div>

        <!-- Einladungsdaten vom Server: Vorname, Firma, maskierte E-Mail (nie die E-Mail aus der URL) -->
        <xds-banner variant="info" data-testid="invitation-preview">
          <span class="invitation-greeting" data-testid="invitation-greeting">{{ greetingText }}</span>
          <span class="invitation-masked-email" *ngIf="preview?.maskedEmail" data-testid="invitation-masked-email">
            {{ "ACCEPT_INV_EMAIL_HINT" | translate: { maskedEmail: preview?.maskedEmail } }}
          </span>
        </xds-banner>

        <!-- GDPR Section -->
        <div class="gdpr-section">
          <!-- Informationspflicht (Art. 13 DSGVO) -->
          <div class="gdpr-info-box">
            <h3 class="gdpr-info-title">
              <i class="fa-light fa-shield-check"></i>
              {{ "GDPR_INFO_TITLE" | translate }}
            </h3>
            <p class="gdpr-intro">{{ "GDPR_INFO_INTRO" | translate }}</p>

            <!-- Expandable Details Toggle -->
            <xds-button
              variant="ghost"
              [iconLeft]="showConsentDetails ? 'fa-light fa-chevron-up' : 'fa-light fa-chevron-down'"
              (clicked)="toggleConsentDetails()"
            >
              {{
                (showConsentDetails ? "HIDE_DETAILS" : "SHOW_DETAILS")
                  | translate
              }}
            </xds-button>

            <!-- Expanded Details -->
            <div class="gdpr-details" *ngIf="showConsentDetails">
              <!-- Was wird verarbeitet -->
              <div class="detail-section">
                <h4>
                  <i class="fa-light fa-database"></i>
                  {{ "GDPR_WHAT_DATA_WE_COLLECT" | translate }}
                </h4>
                <ul>
                  <li>{{ "GDPR_DATA_PERSONAL" | translate }}</li>
                  <li>{{ "GDPR_DATA_WORK_TIME" | translate }}</li>
                  <li>{{ "GDPR_DATA_FINANCIAL" | translate }}</li>
                  <li>{{ "GDPR_DATA_TAX_INSURANCE" | translate }}</li>
                </ul>
              </div>

              <!-- Wie wird es genutzt -->
              <div class="detail-section">
                <h4>
                  <i class="fa-light fa-gears"></i>
                  {{ "GDPR_HOW_WE_USE_DATA" | translate }}
                </h4>
                <ul>
                  <li>{{ "GDPR_USE_TIME_TRACKING" | translate }}</li>
                  <li>{{ "GDPR_USE_VACATION" | translate }}</li>
                  <li>{{ "GDPR_USE_PAYROLL" | translate }}</li>
                  <li>{{ "GDPR_USE_COMMUNICATION" | translate }}</li>
                </ul>
              </div>

              <!-- Ihre Rechte -->
              <div class="detail-section">
                <h4>
                  <i class="fa-light fa-user-shield"></i>
                  {{ "GDPR_YOUR_RIGHTS" | translate }}
                </h4>
                <p>{{ "GDPR_RIGHTS_DESCRIPTION" | translate }}</p>
                <ul>
                  <li>{{ "GDPR_RIGHT_ACCESS" | translate }}</li>
                  <li>{{ "GDPR_RIGHT_RECTIFICATION" | translate }}</li>
                  <li>{{ "GDPR_RIGHT_ERASURE" | translate }}</li>
                  <li>{{ "GDPR_RIGHT_OBJECTION" | translate }}</li>
                </ul>
              </div>
            </div>
          </div>

          <!-- Consent Checkboxes (PFLICHT) -->
          <form [formGroup]="newPasswordForm" class="consent-form">
            <div class="consent-checkboxes" id="consent-checkboxes-section">
              <!-- Privacy Policy -->
              <div class="consent-row consent-row--required">
                <xds-checkbox formControlName="privacyPolicyAccepted" testId="invitation-privacy">
                  <span class="consent-text">
                    {{ "GDPR_I_ACKNOWLEDGE" | translate }}
                    <a
                      [href]="GDPR_CONSTANTS.PRIVACY_URL"
                      target="_blank"
                      rel="noopener noreferrer"
                      (click)="openLink(GDPR_CONSTANTS.PRIVACY_URL, $event)"
                    >
                      {{ "GDPR_PRIVACY_POLICY" | translate }}
                    </a>
                    {{ "GDPR_PRIVACY_ACK_SUFFIX" | translate }}
                    <span class="required-asterisk">*</span>
                  </span>
                </xds-checkbox>
              </div>
              <span
                class="error-message"
                *ngIf="
                  privacyPolicyAccepted?.invalid &&
                  privacyPolicyAccepted?.touched
                "
              >
                {{ "GDPR_PRIVACY_REQUIRED" | translate }}
              </span>

              <!-- Hinweis Arbeitgeberverarbeitung (Information, KEINE Einwilligung) -->
              <xds-banner variant="info" messageKey="GDPR_EMPLOYER_PROCESSING_INFO"></xds-banner>

              <!-- Optional: Marketing Consent -->
              <div class="optional-consents">
                <p class="optional-label">
                  {{ "GDPR_OPTIONAL_CONSENTS" | translate }}
                </p>
                <div class="consent-row consent-row--optional">
                  <xds-checkbox formControlName="marketingConsent" testId="invitation-marketing">
                    <span class="consent-text">
                      {{ "GDPR_MARKETING_CONSENT_TEXT" | translate }}
                    </span>
                  </xds-checkbox>
                </div>
                <p class="consent-help-text">
                  {{ "GDPR_MARKETING_CONSENT_HELP" | translate }}
                </p>
              </div>

              <!-- Required fields notice -->
              <p class="required-notice">
                <span class="required-asterisk">*</span>
                {{ "GDPR_REQUIRED_FIELDS_NOTICE" | translate }}
              </p>
            </div>
          </form>
        </div>

      </div>

      <!-- Step 1 Actions - STICKY BOTTOM BUTTON -->
      <div class="wizard-actions-sticky" *ngIf="currentStep === 1">
        <!-- Progress Info -->
        <div class="consent-progress-info" *ngIf="!canProceedToStep2">
          <i class="fa-light fa-circle-info"></i>
          <span>
            {{ getConsentProgressText() }}
          </span>
        </div>

        <!-- Success Info -->
        <div class="consent-success-info" *ngIf="canProceedToStep2">
          <i class="fa-light fa-circle-check"></i>
          <span>{{ "WIZARD_ALL_CONSENTS_GIVEN" | translate }}</span>
        </div>

        <!-- Continue Button - bleibt klickbar (scrollt bei fehlendem Consent zu den
             Checkboxen); "disabled"-Optik rein über .is-incomplete, KEIN [disabled]
             (das würde den Klick blocken) - identisch zum register-user-Submit. -->
        <xds-button
          variant="primary"
          size="lg"
          [block]="true"
          iconRight="fa-light fa-arrow-right"
          [subdued]="!canProceedToStep2"
          (clicked)="proceedToStep2()"
          data-testid="invitation-continue"
        >
          {{ "WIZARD_CONTINUE" | translate }}
        </xds-button>
      </div>

      <!-- ========================================== -->
      <!-- STEP 2: PASSWORD CREATION -->
      <!-- ========================================== -->
      <div class="wizard-step" *ngIf="currentStep === 2" [@fadeIn]>
        <!-- Greeting — Password-Step (Eyebrow weg, Wizard-Progress oben zeigt schon Step) -->
        <div class="desk-greet">
          <h1>
            <span class="grad">{{ "WIZARD_STEP2_TITLE" | translate }}</span>
          </h1>
          <p class="lede">
            {{ "WIZARD_STEP2_SUBTITLE" | translate }}
          </p>
        </div>

        <!-- Consent Confirmation -->
        <div class="consent-confirmation">
          <i class="fa-light fa-circle-check"></i>
          <span>{{ "WIZARD_CONSENTS_CONFIRMED" | translate }}</span>
        </div>

        <!-- Password Form -->
        <form
          [formGroup]="newPasswordForm"
          autocomplete="off"
          (ngSubmit)="preventFormSubmit($event)"
          class="password-form xds-form-stack"
        >
          <!-- Ablehnung beim Absenden (BE-12 P1): role="alert" vom Kit (variant="danger"), Fokus setzt die Komponente -->
          <div class="submit-error" *ngIf="submitError">
            <xds-banner #submitErrorBanner variant="danger" tabindex="-1" data-testid="invitation-submit-error">{{ submitError }}</xds-banner>
            <xds-button
              *ngIf="showLoginAction"
              variant="secondary"
              iconLeft="fa-light fa-arrow-right-to-bracket"
              (clicked)="goToLogin()"
              data-testid="invitation-go-to-login"
            >
              {{ "GO_TO_LOGIN" | translate }}
            </xds-button>
          </div>

          <!-- Password Field -->
          <xds-form-field
            labelKey="PASSWORD"
            [invalid]="!!(newPasswordForm.get('password')?.invalid && newPasswordForm.get('password')?.dirty)"
            [errorKey]="passwordErrorKey"
          >
            <xds-input
              [type]="showPassword ? 'text' : 'password'"
              formControlName="password"
              placeholderKey="CREATE_YOUR_PASSWORD"
              testId="invitation-password"
              autocomplete="new-password"
              (keydown.enter)="$event.preventDefault()"
              (xdsBlur)="onPasswordBlur()"
              required
            >
              <ng-container ngProjectAs="[xdsInputTrailing]">
                <xds-icon-button
                  [icon]="showPassword ? 'fa-light fa-eye-slash' : 'fa-light fa-eye'"
                  [ariaLabel]="(showPassword ? 'HIDE_PASSWORD' : 'SHOW_PASSWORD') | translate"
                  (clicked)="toggleShowPassword()"
                ></xds-icon-button>
              </ng-container>
            </xds-input>
          </xds-form-field>

          <!-- Password Strength -->
          <div
            class="password-strength"
            *ngIf="newPasswordForm.get('password')?.value"
          >
            <div class="strength-bars">
              <div class="strength-bar" [class.active]="passwordStrength >= 1"></div>
              <div class="strength-bar" [class.active]="passwordStrength >= 2"></div>
              <div class="strength-bar" [class.active]="passwordStrength >= 3"></div>
              <div class="strength-bar" [class.active]="passwordStrength >= 4"></div>
            </div>
            <span class="strength-label">
              {{ getPasswordStrengthLabel() }}
            </span>
          </div>

          <!-- Confirm Password Field -->
          <xds-form-field
            labelKey="CONFIRM PASSWORD"
            [invalid]="!!newPasswordForm.errors?.['notSame']"
            errorKey="These passwords dont match"
          >
            <xds-input
              [type]="showConfirmPassword ? 'text' : 'password'"
              formControlName="confirmPassword"
              placeholderKey="CONFIRM_YOUR_PASSWORD"
              autocomplete="new-password"
              (keydown.enter)="$event.preventDefault()"
              (xdsBlur)="onPasswordConfirmBlur()"
              required
            >
              <ng-container ngProjectAs="[xdsInputTrailing]">
                <xds-icon-button
                  [icon]="showConfirmPassword ? 'fa-light fa-eye-slash' : 'fa-light fa-eye'"
                  [ariaLabel]="(showConfirmPassword ? 'HIDE_PASSWORD' : 'SHOW_PASSWORD') | translate"
                  (clicked)="toggleShowConfirmPassword()"
                ></xds-icon-button>
              </ng-container>
            </xds-input>
          </xds-form-field>
        </form>
      </div>

      <!-- Step 2 Actions - STICKY BOTTOM BUTTON -->
      <div class="wizard-actions-sticky step2-actions" *ngIf="currentStep === 2">
        <!-- Password validation info -->
        <div class="password-validation-info" *ngIf="!newPasswordForm.valid && newPasswordForm.dirty">
          <i class="fa-light fa-triangle-exclamation"></i>
          <span>{{ "WIZARD_PASSWORD_REQUIREMENTS" | translate }}</span>
        </div>

        <!-- Ready to submit -->
        <div class="password-ready-info" *ngIf="newPasswordForm.valid">
          <i class="fa-light fa-circle-check"></i>
          <span>{{ "WIZARD_PASSWORD_READY" | translate }}</span>
        </div>

        <!-- MAIN ACTION BUTTON - Full Width -->
        <xds-button
          variant="primary"
          size="lg"
          [block]="true"
          iconLeft="fa-light fa-user-check"
          [disabled]="!newPasswordForm.valid"
          (clicked)="onSubmit()"
          data-testid="invitation-complete"
        >
          {{ "WIZARD_COMPLETE" | translate }}
        </xds-button>

        <!-- Back Button - Secondary, smaller -->
        <xds-button
          variant="ghost"
          iconLeft="fa-light fa-arrow-left"
          (clicked)="backToStep1()"
        >
          {{ "WIZARD_BACK" | translate }}
        </xds-button>
      </div>
      </ng-container>
    </div>
  </div>
</div>
